import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useWeb3React } from "@web3-react/core";
import { Contract } from "@ethersproject/contracts";
import { getNativeByChain } from "helpers/networks";
import { getCollectionsByChain } from "helpers/collections";
import { useMoralis, useMoralisQuery } from "react-moralis";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import SafeMarsNFTContractJSON from "../contracts/SafeMarsNFT.json";

function Mint({ web3 }) {
  const { tokenAddr, tokenId } = useParams();
  const fallbackImg =
    "data:image/png;base64,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";

  const [price, setPrice] = useState(1);

  const [loading, setLoading] = useState(false);
  const [tokenDetails, setTokenDetails] = useState(null);
  const { account, library, active } = useWeb3React();
  const inputFile = useRef(null);
  const [message, setMessage] = useState("");

  const storeMetdata = async (tokenURI) => {
    try {
      const safeMarsNFTContract = new library.eth.Contract(
        SafeMarsNFTContractJSON.abi,
        process.env.REACT_APP_SAFEMARS_NFT
      );

      await toast.promise(
        safeMarsNFTContract.methods.mint(tokenURI).send({ from: account }),
        {
          pending: "Minting...",
          success: "Minted successfully",
          error: "Failed to mint",
        }
      );

      // setMessage("Minted Successfully");
      // console.log(ret);
    } catch (err) {
      // console.log(err);
    }
  };

  const openFileUploader = (evt) => {
    inputFile.current.click();
  };

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setMessage("");
    // setMessage("Uploading...");
    try {
      const data = new FormData(evt.target);
      if (data.get("file").size === 0) {
        setMessage("Select a file to mint");
        return;
      }

      const resp = await toast.promise(
        fetch(`${process.env.REACT_APP_API_URL}/mint`, {
          method: "POST",
          body: data,
        }),
        {
          pending: "Uploading...",
          success: "Uploaded successfully",
          error: "File already minted",
        }
      );

      const status = resp.status;

      const json = await resp.json();

      if (status !== 200) {
        setMessage(json.error);
        return;
      }

      const tokenURI = json.tokenURI;
      // setMessage("Minting...");

      storeMetdata(tokenURI);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <ToastContainer />
      <section className="py-5">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-12 advanced_form">
              {!active && <div>Connect wallet to mint</div>}
              {active && (
                <form
                  className="p-4 p-lg-5 bg-dark form_container col-12 form advanced_form_main"
                  id="advanced_form_main"
                  cluster-url="ajax/save_nft_mining"
                  cluster-warning="Please wait while we save...."
                  cluster-after="openNextForm()"
                  onSubmit={handleSubmit}
                >
                  {/* <h3 className="col-12 hcenter white-color">
                  Minting Cost = $10
                </h3> */}
                  <div className="row gy-3 py-4">
                    <div className="error-main col-12"></div>

                    <input type="hidden" name="creator" value={account} />
                    <div className="col-12 top-margin form-group input-container">
                      <label className="col-12 no-padding form-label text-gray-400">
                        NFT Name
                      </label>
                      <input
                        type="text"
                        className="form-control nft_name required"
                        placeholder="Enter the artwork name"
                        name="name"
                        required
                      />
                      <div className="error-input"></div>
                    </div>
                    {/* <div className="col-12  top-margin form-group input-container">
                    <label className="col-12 no-padding form-label text-gray-400">
                      Artist Name
                    </label>
                    <input
                      type="text"
                      className="form-control artist_name required"
                      placeholder="Enter the artist name"
                      name="artist_name"
                    />
                    <div className="error-input"></div>
                  </div> */}
                    <div className="col-12  top-margin form-group input-container">
                      <label className="col-12 no-padding form-label text-gray-400">
                        NFT Link (Website etc..)
                      </label>
                      <input
                        type="text"
                        className="form-control nft_link required"
                        placeholder="Personal Website, Instagram, Twitter etc"
                        name="link"
                      />
                      <div className="error-input"></div>
                    </div>
                    <div className="col-12  top-margin form-group input-container">
                      <label className="col-12 no-padding form-label text-gray-400">
                        NFT Description
                      </label>
                      <textarea
                        className="form-control nft_description required"
                        placeholder="Enter the breif Introduction"
                        name="description"
                        required
                      ></textarea>
                      <div className="error-input"></div>
                    </div>
                  </div>

                  <div className="form-group input-container file_upload_container row top-margin">
                    <div className="col-12">
                      <h5 className="col-12 hcenter form-label text-gray-400">
                        Upload NFT Image
                      </h5>
                      {/* <input
                        type="file"
                        id="file"
                        name="file"
                        accept="image/*,audio/*,video/*"
                        ref={inputFile}
                        style={{ display: "none" }}
                      /> */}
                      <input
                        type="file"
                        id="file"
                        name="file"
                        accept="image/*, audio/*, video/*"
                        ref={inputFile}
                        style={{ display: "none" }}
                      />

                      <button
                        type="button"
                        className="btn btn-primary fileinput-button"
                        onClick={openFileUploader}
                        style={{ margin: "0 auto" }}
                      >
                        <i className="glyphicon glyphicon-plus"></i>
                        <span>Select file</span>
                      </button>
                      <br />
                      <br />

                      {/* <div className="progress col-12 top-margin no-padding">
                      <div className="progress-bar progress-bar-success"></div>
                    </div> */}

                      <div className="files_area top-margin"></div>
                      <div className="file_name"></div>
                      <div className="error_area col-12 top-margin"></div>

                      <div className="error-input"></div>
                    </div>
                  </div>

                  <div className="row gy-3 py-4">
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary btn-submit"
                        id="btn-submit-advanced"
                      >
                        <i className="las la-plus-circle me-2"></i>Save and
                        continue
                      </button>
                      <br /> <br />
                      <span>{message}</span>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
      <div
        className="col-lg-6 result_form_1 offset-lg-3"
        style={{ display: "none" }}
      >
        <div className="card shadow mb-4">
          <div className="card-body">
            <div className="row">
              <div className="col-12 top-margin">
                <div className="row">
                  <h4 className="col-12 nft-name pb-0 mb-0" id="preview_name">
                    BakedCake NFT
                  </h4>
                  <p className="col-lg-6" id="preview_author">
                    <small>By: TheCreato </small>
                  </p>{" "}
                  <p className="text-right col-lg-6" id="preview_link">
                    {" "}
                    <small>0x87b4...6BC9</small>
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12  pt-0 no-padding">
                <p className="col-12 nft-desc no-padding" id="preview_desc">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
                  posuere elit nunc, ac lobortis quam fermentum et. Integer vel
                  ex quis purus euismod auctor ut non lorem.
                </p>
              </div>
              <div className="col-12 top-margin no-padding nft_preview_medium_container">
                <img className="col-12 nft-img no-padding" src="" />
              </div>
              <div className="col-12 top-margin no-padding">
                <button
                  type="button"
                  className="btn btn-primary btn-info-full next-step btn-submit"
                  id="btn-submit-nft"
                  style={{ marginTop: "15px" }}
                >
                  Mint NFT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="col-lg-6 result_form_2 offset-lg-3"
        style={{ display: "none" }}
      >
        <div className="card shadow mb-4">
          <div className="card-body">
            <div className="row">
              <div className="col-12 top-margin">
                <div className="row">
                  <h4 className="col-12 nft-name pb-0 mb-0">BakedCake NFT</h4>
                  <p className="col-lg-6">
                    <small>By: TheCreato </small>
                  </p>{" "}
                  <p className="text-right col-lg-6">
                    {" "}
                    <small>0x87b4...6BC9</small>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12  pt-0 no-padding">
              <p className="col-12 nft-desc no-padding">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
                posuere elit nunc, ac lobortis quam fermentum et. Integer vel ex
                quis purus euismod auctor ut non lorem.
              </p>
            </div>
            <div className="col-12 top-margin no-padding nft_preview_medium_container">
              <img className="col-12 nft-img no-padding" src="" />
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal bakedCakeModal"
        tabIndex="-1"
        role="dialog"
        id="addressModal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <textarea
                className="form-control"
                placeholder="Enter Wallet To receive the NFT 0x35ca6D6933cEF9A93Ac3Cc42419769CD0b091f34"
                id="address_textarea"
                style={{ backgroundColor: "#f7d171", color: "black" }}
              ></textarea>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                id="save_address"
              >
                Save changes
              </button>
              <button
                type="button"
                className="btn btn-secondary btn-close-button-modal"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="alertModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <p
                id="modal_text"
                className="hcenter"
                style={{ color: "black" }}
              ></p>
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mint;
